// @ts-nocheck
export function rm_double(items, prop) {
	if (!Array.isArray(items)) return [];

	const getKey = typeof prop === "function" ? prop : (item) => item?.[prop];

	return items.filter((item, index, self) => {
		const key = getKey(item);

		if (!key) {
			return true;
		}

		return self.findIndex((t) => getKey(t) === key) === index;
	});
}

export function rm_double_2D(items, prop) {
	let arr = [];
	let indexes = [];
	if (!items || !items.length) return arr;
	for (let x = 0; x < items.length; x++) {
		for (let y = 0; y < items[x]?.length; y++) {
			if (indexes.indexOf(items[x][y][prop]) === -1) {
				arr.push(items[x][y]);
				indexes.push(items[x][y][prop]);
			}
		}
	}
	return arr;
}
